export default {
 notification: {
   read: "읽음",
   unread: "읽지 않음",
   hide: "숨기기",
   showAll: "모두 보기",
   loading: "로딩 중...",
   noMore: "더 이상 데이터가 없습니다",
   platform: "플랫폼",
   personal: "개인"
 }
};
